import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  DEMO_LESSON_COURSE_ALL,
  DEMO_LESSON_COURSE_CREATE,
  DEMO_LESSON_COURSE_DELETE,
  DEMO_LESSON_COURSE_LIST,
  DEMO_LESSON_EVALUATION_ASSIGNED,
  DEMO_LESSON_EVALUATION_CATEGORY,
  DEMO_LESSON_EVALUATION_CREATE,
  DEMO_LESSON_EVALUATION_LIST,
  DEMO_LESSON_EVALUATION_PRINCIPAL,
  DEMO_LESSON_EVALUATION_REPORT,
  DEMO_LESSON_EVALUATION_RESPONSE_ALL,
  DEMO_LESSON_EVALUATION_RESPONSE_CREATE,
  DEMO_LESSON_MODULE_ALL,
  DEMO_LESSON_MODULE_CREATE,
  DEMO_LESSON_MODULE_DELETE,
  DEMO_LESSON_MODULE_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const DEMO_LESSON_EVALUATION = GLOBAL_STATE

const demoLessonEvaluationSlice = createSlice({
  name: DEMO_LESSON_EVALUATION,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.demoLessonEvaluationCreate.pending, state => {
        state[DEMO_LESSON_EVALUATION_CREATE].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationCreate.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_CREATE].loading = false
        state[DEMO_LESSON_EVALUATION_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationCreate.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_CREATE].loading = false
        state[DEMO_LESSON_EVALUATION_CREATE].error = null
        state[DEMO_LESSON_EVALUATION_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationList.pending, state => {
        state[DEMO_LESSON_EVALUATION_LIST].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationList.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_LIST].loading = false
        state[DEMO_LESSON_EVALUATION_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationList.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_LIST].loading = false
        state[DEMO_LESSON_EVALUATION_LIST].error = null
        state[DEMO_LESSON_EVALUATION_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationCategory.pending, state => {
        state[DEMO_LESSON_EVALUATION_CATEGORY].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationCategory.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_CATEGORY].loading = false
        state[DEMO_LESSON_EVALUATION_CATEGORY].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationCategory.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_CATEGORY].loading = false
        state[DEMO_LESSON_EVALUATION_CATEGORY].error = null
        state[DEMO_LESSON_EVALUATION_CATEGORY].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationPrincipal.pending, state => {
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationPrincipal.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].loading = false
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationPrincipal.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].loading = false
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].error = null
        state[DEMO_LESSON_EVALUATION_PRINCIPAL].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationResponseCreate.pending, state => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationResponseCreate.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].loading = false
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationResponseCreate.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].loading = false
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].error = null
        state[DEMO_LESSON_EVALUATION_RESPONSE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationResponseAll.pending, state => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationResponseAll.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].loading = false
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationResponseAll.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].loading = false
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].error = null
        state[DEMO_LESSON_EVALUATION_RESPONSE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationAssigned.pending, state => {
        state[DEMO_LESSON_EVALUATION_ASSIGNED].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationAssigned.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_ASSIGNED].loading = false
        state[DEMO_LESSON_EVALUATION_ASSIGNED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationAssigned.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_ASSIGNED].loading = false
        state[DEMO_LESSON_EVALUATION_ASSIGNED].error = null
        state[DEMO_LESSON_EVALUATION_ASSIGNED].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonCourseAll.pending, state => {
        state[DEMO_LESSON_COURSE_ALL].loading = true
      })
      .addCase(actionCreators.demoLessonCourseAll.rejected, (state, action) => {
        state[DEMO_LESSON_COURSE_ALL].loading = false
        state[DEMO_LESSON_COURSE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonCourseAll.fulfilled, (state, action) => {
        state[DEMO_LESSON_COURSE_ALL].loading = false
        state[DEMO_LESSON_COURSE_ALL].error = null
        state[DEMO_LESSON_COURSE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonCourseCreate.pending, state => {
        state[DEMO_LESSON_COURSE_CREATE].loading = true
      })
      .addCase(actionCreators.demoLessonCourseCreate.rejected, (state, action) => {
        state[DEMO_LESSON_COURSE_CREATE].loading = false
        state[DEMO_LESSON_COURSE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonCourseCreate.fulfilled, (state, action) => {
        state[DEMO_LESSON_COURSE_CREATE].loading = false
        state[DEMO_LESSON_COURSE_CREATE].error = null
        state[DEMO_LESSON_COURSE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonCourseDelete.pending, state => {
        state[DEMO_LESSON_COURSE_DELETE].loading = true
      })
      .addCase(actionCreators.demoLessonCourseDelete.rejected, (state, action) => {
        state[DEMO_LESSON_COURSE_DELETE].loading = false
        state[DEMO_LESSON_COURSE_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonCourseDelete.fulfilled, (state, action) => {
        state[DEMO_LESSON_COURSE_DELETE].loading = false
        state[DEMO_LESSON_COURSE_DELETE].error = null
        state[DEMO_LESSON_COURSE_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonCourseList.pending, state => {
        state[DEMO_LESSON_COURSE_LIST].loading = true
      })
      .addCase(actionCreators.demoLessonCourseList.rejected, (state, action) => {
        state[DEMO_LESSON_COURSE_LIST].loading = false
        state[DEMO_LESSON_COURSE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonCourseList.fulfilled, (state, action) => {
        state[DEMO_LESSON_COURSE_LIST].loading = false
        state[DEMO_LESSON_COURSE_LIST].error = null
        state[DEMO_LESSON_COURSE_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonModuleAll.pending, state => {
        state[DEMO_LESSON_MODULE_ALL].loading = true
      })
      .addCase(actionCreators.demoLessonModuleAll.rejected, (state, action) => {
        state[DEMO_LESSON_MODULE_ALL].loading = false
        state[DEMO_LESSON_MODULE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonModuleAll.fulfilled, (state, action) => {
        state[DEMO_LESSON_MODULE_ALL].loading = false
        state[DEMO_LESSON_MODULE_ALL].error = null
        state[DEMO_LESSON_MODULE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonModuleCreate.pending, state => {
        state[DEMO_LESSON_MODULE_CREATE].loading = true
      })
      .addCase(actionCreators.demoLessonModuleCreate.rejected, (state, action) => {
        state[DEMO_LESSON_MODULE_CREATE].loading = false
        state[DEMO_LESSON_MODULE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonModuleCreate.fulfilled, (state, action) => {
        state[DEMO_LESSON_MODULE_CREATE].loading = false
        state[DEMO_LESSON_MODULE_CREATE].error = null
        state[DEMO_LESSON_MODULE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonModuleDelete.pending, state => {
        state[DEMO_LESSON_MODULE_DELETE].loading = true
      })
      .addCase(actionCreators.demoLessonModuleDelete.rejected, (state, action) => {
        state[DEMO_LESSON_MODULE_DELETE].loading = false
        state[DEMO_LESSON_MODULE_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonModuleDelete.fulfilled, (state, action) => {
        state[DEMO_LESSON_MODULE_DELETE].loading = false
        state[DEMO_LESSON_MODULE_DELETE].error = null
        state[DEMO_LESSON_MODULE_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonModuleList.pending, state => {
        state[DEMO_LESSON_MODULE_LIST].loading = true
      })
      .addCase(actionCreators.demoLessonModuleList.rejected, (state, action) => {
        state[DEMO_LESSON_MODULE_LIST].loading = false
        state[DEMO_LESSON_MODULE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonModuleList.fulfilled, (state, action) => {
        state[DEMO_LESSON_MODULE_LIST].loading = false
        state[DEMO_LESSON_MODULE_LIST].error = null
        state[DEMO_LESSON_MODULE_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.demoLessonEvaluationReport.pending, state => {
        state[DEMO_LESSON_EVALUATION_REPORT].loading = true
      })
      .addCase(actionCreators.demoLessonEvaluationReport.rejected, (state, action) => {
        state[DEMO_LESSON_EVALUATION_REPORT].loading = false
        state[DEMO_LESSON_EVALUATION_REPORT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.demoLessonEvaluationReport.fulfilled, (state, action) => {
        state[DEMO_LESSON_EVALUATION_REPORT].loading = false
        state[DEMO_LESSON_EVALUATION_REPORT].error = null
        state[DEMO_LESSON_EVALUATION_REPORT].data = action.payload
      })

    builder.addCase(actionCreators.demoLessonCourseAllClear, state => {
      state[DEMO_LESSON_COURSE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonCourseListClear, state => {
      state[DEMO_LESSON_COURSE_LIST] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonModuleAllClear, state => {
      state[DEMO_LESSON_MODULE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonModuleListClear, state => {
      state[DEMO_LESSON_MODULE_LIST] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationListClear, state => {
      state[DEMO_LESSON_EVALUATION_LIST] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationCategoryClear, state => {
      state[DEMO_LESSON_EVALUATION_CATEGORY] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationPrincipalClear, state => {
      state[DEMO_LESSON_EVALUATION_PRINCIPAL] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationResponseAllClear, state => {
      state[DEMO_LESSON_EVALUATION_RESPONSE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationAssignedClear, state => {
      state[DEMO_LESSON_EVALUATION_ASSIGNED] = defaultState()
    })

    builder.addCase(actionCreators.demoLessonEvaluationReportClear, state => {
      state[DEMO_LESSON_EVALUATION_REPORT] = defaultState()
    })
  },
})

export const { reducer: demoLessonEvaluationReducer } = demoLessonEvaluationSlice
